"use client";

/**
 * ExecutorRow — initial avatar + nickname + WalletAddress for executed proposals (V3)
 *
 * Figma 5462:53207 V3 bottom card — executor section.
 */

import { WalletAddress } from "@/components/core/WalletAddress";

interface ExecutorRowProps {
  address: string;
  nickname: string | null;
}

export function ExecutorRow({ address, nickname }: ExecutorRowProps) {
  return (
    <div className="flex min-w-0 items-center gap-3">
      <div className="w-8 h-8 rounded-full bg-bg-tertiary flex items-center justify-center text-sm font-semibold text-text-primary shrink-0">
        {nickname ? nickname[0] : address.slice(2, 4).toUpperCase()}
      </div>
      <div className="flex min-w-0 flex-1 flex-col gap-0.5">
        {nickname && (
          <span className="truncate text-sm font-medium text-text-primary">
            {nickname}
          </span>
        )}
        <WalletAddress address={address} size={16} canCopy />
      </div>
    </div>
  );
}
